<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import OverviewRankRow from './OverviewRankRow.vue'

const page     = usePage()
const topForms = computed(() => page.props.__neo_main?.__data?.topForms ?? [])
const maxCount = computed(() => Math.max(...topForms.value.map(f => f.count), 1))
</script>

<template>
    <div>
        <div v-if="!topForms.length" class="text-[13px] text-gray-400 dark:text-neutral-500 py-3">{{ $t('dashboard.topforms_empty') }}</div>
        <OverviewRankRow
            v-for="(form, i) in topForms"
            :key="form.id"
            :rank="i + 1"
            :form="form"
            :max-count="maxCount"
        />
    </div>
</template>
